import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpGetDeclineReasons} from '@features/assignment/http/assignment.http'
import {captureException} from '@sentry/react'
import {DeclineReason} from '@features/assignment/types.ts'
import {z} from 'zod'
import {parseAxiosPromise} from '@/axiosInstance.ts'

export const useDeclineReasons = () =>
    useQuery({
        queryKey: [QUERY_KEYS.DECLINE_REASONS],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetDeclineReasons(),
                responseShape: z.array(DeclineReason).min(1),
                onZodError: captureException
            })
    })
